import React, { Component } from "react";
import logo from "../images/ipark-logo.png";
import { Link, NavLink } from "react-router-dom";
import "../styles/navbar.css";

class NavbarHome extends Component {
  render() {
    return (
      <div>
        <div className="navbar navbar-expand-lg navbar-light p-0">
          <button
            className="navbar-toggler"
            data-toggle="collapse"
            data-target="#collapse_target"
          >
            <span className="navbar-toggler-icon"></span>
            <Link className="navbar-brand nav-logo-mobile" to="/">
              <img src={logo} alt="" className="" />
            </Link>
            <Link
              className="col-sm text-right mr-1 navbar-button-mobile"
              to="/login"
            >
              <button className="btn navbar-button">Login</button>
            </Link>
          </button>
          <div className="collapse navbar-collapse" id="collapse_target">
            <Link className="navbar-brand p-3 nav-brand-logo" to="/">
              <img src={logo} alt="" className="" />
            </Link>
            <ul className="navbar-nav text-center list-div">
              <li className="nav-item">
                <NavLink className="navbar-links" to="/about" exact>
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="navbar-links" to="/" exact>
                  About
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="navbar-links" to="/" exact>
                  Contact
                </NavLink>
              </li>
            </ul>
            <Link
              className="col-sm text-right mr-1 navbar-button-div"
              to="/login"
            >
              <button className="btn navbar-button">Login</button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default NavbarHome;
